import Modal from '@lyra/core/components/Modal'
import Section from '@lyra/core/components/Section'
import { TRADE_RIGHT_RAIL_WIDTH_DESKTOP } from '@lyra/web/constants/layout'
import { Order, OrderType, TimeInForce } from '@lyra/web/constants/order'
import useOrderParamsForInstrument from '@lyra/web/hooks/useOrderParamsForInstrument'
import useTicker from '@lyra/web/hooks/useTicker'
import { getDefaultOrderQuoteParams } from '@lyra/web/utils/order'

import TradeForm from '../trade/TradeForm'

type Props = {
  order: Order
  onClose: () => void
}

export default function EditOrderModal({ order, onClose }: Props) {
  const ticker = useTicker(order.instrument_name)
  const [orderParams, setOrderParams] = useOrderParamsForInstrument(order.instrument_name, {
    ...getDefaultOrderQuoteParams(order.instrument_name),
    amount: (Math.abs(+order.amount) - Math.abs(+order.filled_amount)).toString(),
    limit_price: order.limit_price,
    order_type: order.order_type as OrderType,
    direction: order.direction,
    time_in_force: order.time_in_force as TimeInForce,
  })

  return (
    <Modal
      title="Edit Order"
      isOpen
      onChangeOpen={onClose}
      desktopWidth={TRADE_RIGHT_RAIL_WIDTH_DESKTOP}
    >
      {ticker ? (
        <TradeForm
          editOrderId={order.order_id}
          ticker={ticker}
          orderParams={orderParams}
          setOrderParams={setOrderParams}
          onSubmitOrder={onClose}
          showMarkPrice
        />
      ) : (
        <Section.Spinner />
      )}
    </Modal>
  )
}
